// Sun Valley : code de bienvenue dans l'onglet « Offres » du tiroir panier.
// Le client saisit son e-mail et coche l'inscription à la newsletter sans quitter le panier ; le
// formulaire client Shopify part en arrière-plan, puis le code est appliqué au panier (API Ajax
// cart/update.js, comme le champ code promo de Stretch) et affiché. On ne quitte jamais le tunnel :
// si Shopify réclame une vérification anti-robot pour l'inscription, le code est quand même appliqué.
// L'état est mémorisé sur l'appareil (localStorage). Élément rendu par sections/cart-drawer.liquid.
(() => {
  // Textes traduits (snippets/sv-textes-js.liquid) ; à défaut, la clé
  const T = (cle, v) => (window.svT ? window.svT(cle, v) : cle);
  const CLE = 'sv_code_bienvenue';
  const lire = () => { try { return localStorage.getItem(CLE) === '1'; } catch (e) { return false; } };
  const retenir = () => { try { localStorage.setItem(CLE, '1'); } catch (e) { /* stockage indisponible */ } };
  const racine = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  async function appliquerCode(code) {
    try {
      const panier = await (await fetch(`${racine()}cart.js`)).json();
      const existants = (panier.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
      if (existants.some((c) => c.toLowerCase() === code.toLowerCase())) return true;
      const r = await fetch(`${racine()}cart/update.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: existants.concat(code).join(',') }),
      });
      const j = await r.json();
      const ok = (j.discount_codes || []).some((d) => d.code.toLowerCase() === code.toLowerCase() && d.applicable);
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      return ok;
    } catch (e) { return false; }
  }

  // La fenêtre d'inscription (sections/newsletter-popup.liquid) ne s'ouvre jamais par-dessus le
  // bandeau cookies de Shopify : les deux se posaient en bas à gauche, et le bandeau masquait le
  // champ e-mail et le bouton. Elle attend que le visiteur ait répondu aux cookies, puis quatre
  // secondes. Elle ne s'ouvre pas non plus si le code a déjà été obtenu, ici ou dans le panier.
  // L'éditeur de thème garde le comportement d'origine, pour pouvoir la travailler.
  const bandeauCookies = () => {
    const b = document.getElementById('shopify-pc__banner');
    if (!b) return false;
    const s = getComputedStyle(b);
    return b.offsetWidth > 0 && s.display !== 'none' && s.visibility !== 'hidden';
  };
  customElements.whenDefined('newsletter-popup').then(() => {
    const Fenetre = customElements.get('newsletter-popup');
    const ouvrir = Fenetre.prototype.show;
    Fenetre.prototype.show = function (...args) {
      if (window.Shopify && Shopify.designMode) return ouvrir.apply(this, args);
      if (lire()) return undefined;
      if (!bandeauCookies()) return ouvrir.apply(this, args);
      const fenetre = this;
      let fait = false;
      const apres = () => {
        if (fait || bandeauCookies()) return;
        fait = true;
        clearInterval(veille);
        setTimeout(() => { if (!lire()) ouvrir.apply(fenetre, args); }, 4000);
      };
      const veille = setInterval(apres, 500);
      document.addEventListener('visitorConsentCollected', () => setTimeout(apres, 50), { once: true });
      return undefined;
    };
  });

  if (customElements.get('sv-code-newsletter')) return;
  customElements.define('sv-code-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.avant = this.querySelector('.sv-code__avant');
      this.apres = this.querySelector('.sv-code__apres');
      this.form = this.querySelector('form');
      this.erreur = this.querySelector('.sv-code__erreur');
      this.code = this.dataset.code || '';
      if (lire()) { this.devoiler(); return; }
      if (this.form) this.form.addEventListener('submit', (e) => this.envoyer(e));
    }

    devoiler() {
      if (this.avant) this.avant.hidden = true;
      if (this.apres) this.apres.hidden = false;
      // Code obtenu : la fenêtre d'inscription n'a plus rien à proposer, elle ne revient pas.
      try { localStorage.setItem('theme:popup-filled', 'true'); } catch (e) { /* stockage indisponible */ }
    }

    async envoyer(e) {
      e.preventDefault();
      const form = this.form;
      const email = form.querySelector('input[type="email"]');
      const accord = form.querySelector('input[type="checkbox"]');
      if (!email || !email.value || (accord && !accord.checked)) {
        if (this.erreur) { this.erreur.hidden = false; this.erreur.textContent = accord && !accord.checked ? T('code_newsletter.cocher') : T('commun.email_manquant'); }
        return;
      }
      if (this.erreur) this.erreur.hidden = true;
      const bouton = form.querySelector('button[type="submit"]');
      if (bouton) bouton.disabled = true;
      let inscrit = false;
      try {
        const r = await fetch(form.action, { method: 'POST', body: new FormData(form), headers: { 'Accept': 'text/html' }, redirect: 'follow' });
        inscrit = r.ok && !/challenge/.test(r.url);
      } catch (err) { inscrit = false; }
      if (!inscrit) console.info('Sun Valley : inscription newsletter non confirmée par Shopify (vérification demandée), le code est appliqué quand même.');
      // Jamais de sortie du tunnel : le code est appliqué et dévoilé dans tous les cas.
      retenir();
      this.devoiler();
      const applique = await appliquerCode(this.code);
      const statut = this.querySelector('.sv-code__statut');
      if (statut) { statut.hidden = false; statut.textContent = applique ? T('code_newsletter.applique') : T('code_newsletter.saisir'); }
      if (bouton) bouton.disabled = false;
    }
  });
})();
